import { render, staticRenderFns } from "./ComandoVelocidadPantalla.vue?vue&type=template&id=5c29ce20&"
import script from "./ComandoVelocidadPantalla.vue?vue&type=script&lang=ts&"
export * from "./ComandoVelocidadPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports